import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.css']
})
export class DoughnutChartComponent {

    // Doughnut
    @Input() public doughnutChartLabels = ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'];
    @Input() public doughnutChartData = [350, 450, 100];
    public doughnutChartType = 'doughnut';

    constructor() { }
    // events
    public chartClicked(e: any): void {
      console.log(e);
    }

    public chartHovered(e: any): void {
      console.log(e);
    }


}



// WEBPACK FOOTER //
// ./src/app/report/charts/doughnut-chart/doughnut-chart.component.ts